import React, { createContext, useContext, useEffect, useState } from 'react'
import useCheckMobileScreen from '../hooks/useCheckMobileScreen';
import { getConfig } from '../../services';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

const activeTab = localStorage.getItem("insightTab") || 'success';

function AppContextProvider({ children }) {
    const [insightTab, setInsightTab] = useState(activeTab);
    const [environment, setEnvironment] = useState('development');
    const [currentPage, setCurrentPage] = useState(1);

    const configHandler = async () => {
        try {
            const {data} = await getConfig();
            
            if(data && data.REACT_APP_BBY_ENV){
                setEnvironment(data.REACT_APP_BBY_ENV);
            }
        } catch (error) {
            return error?.message;
        }
    }

    const tabHandler = (tab) => {
        setInsightTab(tab);
    }

    const getCurrentPage = (num) => {
        setCurrentPage(num);
    }

    useEffect(() => {
        configHandler();
        return () => {
            configHandler();
        }
    },[])
    useEffect(() => {
        if(insightTab)
        {
            localStorage.setItem("insightTab",insightTab);
            if(localStorage.getItem("insightTab")){
                setInsightTab(localStorage.getItem("insightTab"));
            }
        }
    },[insightTab])

    const isMobile = useCheckMobileScreen();
    const [notification, setNotification] = useState(true);
    
    const contextObj = { 
        isMobile,insightTab, tabHandler,
        currentPage,
        getCurrentPage,
        notification,
        setNotification,
        environment
    }
    return (
        <AppContext.Provider value={contextObj}>
            {children}
        </AppContext.Provider>
    )
}

export default AppContextProvider